import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import { LaneDetailsService } from '../../../interfaces/marketInsightsUiServiceInterfaces';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';

export const LANE_DETAILS_YEAR_REQUEST = 'LANE_DETAILS_YEAR_REQUEST';
export const LANE_DETAILS_YEAR_SUCCESS = 'LANE_DETAILS_YEAR_SUCCESS';
export const LANE_DETAILS_YEAR_FAILURE = 'LANE_DETAILS_YEAR_FAILURE';

const requestLaneDetailsYear = (): object => {
    return {
        type: LANE_DETAILS_YEAR_REQUEST
    };
};

const receiveLaneDetailsYear = (json: object): object => {
    return {
        type: LANE_DETAILS_YEAR_SUCCESS,
        payload: json
    };
};

const requestLaneDetailsYearFailed = (): object => {
    return {
        type: LANE_DETAILS_YEAR_FAILURE
    };
};

export const fetchLaneDetailsYear = (searchQuery: any, months: number = 12): Function => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestLaneDetailsYear());

        const requestBody = [{
            ...searchQuery,
            months
        }];
        try {
            const json = await ApiService.post(Endpoints.laneDetails, requestBody);
            if (json && Array.isArray(json.data) && json.data[0].length > 0) {
                const jsonData: LaneDetailsService[] = json.data[0];
                dispatch(receiveLaneDetailsYear(jsonData));
            } else {
                dispatch(requestLaneDetailsYearFailed());
                dispatch(enqueueSnackbar({
                    message: 'Not enough loads to provide lane details for current year.',
                    variant: SnackbarMessageVariants.Info
                }));
            }
        } catch (err) {
            dispatch(requestLaneDetailsYearFailed());
            dispatch(enqueueSnackbar({
                message: 'Error has occurred while fetching lane details for yearly data.',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
